export const PorangeText = ({ children }) =>
    <span className="porange-text-gradient text-[20px] font-mont-bold">{children}</span>;
